import { isTeams } from './teamsTab';
import { isNativeAppWebview } from './webapp';

export function isNativeAppWenViewOrTeams() {
  return isNativeAppWebview() || isTeams();
}
